export default __webpack_public_path__ + "static/media/dogs-of-elon.d2be8e84.jpg";